/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { renderPersonItem } from './managersArchitectCardTooltip';

const ManagersArchitectsCard = ({
  srManagerDisplay,
  srManagerDetails,
  managerRows,
  srArchitects,
  architects,
  deliveryManagerRows,
}) => {
  const hasSrArchitects = Array.isArray(srArchitects) && srArchitects.length > 0;
  const hasArchitects = Array.isArray(architects) && architects.length > 0;
  const hasSrManager = Boolean(srManagerDisplay && String(srManagerDisplay).trim());
  const hasManagers = Array.isArray(managerRows) && managerRows.length > 0;
  const hasDeliveryManagers = Array.isArray(deliveryManagerRows) && deliveryManagerRows.length > 0;

  const [activeId, setActiveId] = useState(null);
  const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });

  return (
    <div className="card manager-architect-card">
      <div className="card-content">
        <div className="combined-list">
          <div className="section-divider">
            <h4 className="section-title">Delivery Manager</h4>
          </div>

          <div className={`list-section ${hasDeliveryManagers ? '' : 'is-empty'}`}>
            {hasDeliveryManagers ? deliveryManagerRows.map((person, idx) => (
              renderPersonItem(person, `delivery-${idx}`, 'regular', setActiveId, activeId, tooltipCoords, setTooltipCoords)
            )) : (
              <div className="no-data-state">No Delivery Manager assigned</div>
            )}
          </div>

          <div className="section-divider">
            <h4 className="section-title">Sr Manager / Manager</h4>
          </div>

          <div className={`list-section ${(hasSrManager || hasManagers) ? '' : 'is-empty'}`}>
            {hasSrManager ? (
              renderPersonItem({ name: srManagerDisplay, details: srManagerDetails }, 'sr', 'senior', setActiveId, activeId, tooltipCoords, setTooltipCoords)
            ) : (
              <div className="no-data-state">No SR manager assigned</div>
            )}
            {hasManagers ? managerRows.map((person, idx) => renderPersonItem(person, idx, 'regular', setActiveId, activeId, tooltipCoords, setTooltipCoords)) : null}
          </div>

          <div className="section-divider">
            <h4 className="section-title">Sr Architect / Architect</h4>
          </div>

          <div className={`list-section ${(hasSrArchitects || hasArchitects) ? '' : 'is-empty'}`}>
            {hasSrArchitects ? srArchitects.map((person, idx) => (
              renderPersonItem(person, idx, 'senior', setActiveId, activeId, tooltipCoords, setTooltipCoords)
            )) : null}
            {hasArchitects ? architects.map((person, idx) => (
              renderPersonItem(person, `architect-${idx}`, 'regular', setActiveId, activeId, tooltipCoords, setTooltipCoords)
            )) : null}
            {!hasSrArchitects && !hasArchitects ? (
              <div className="no-data-state">No Sr Architect/Architect assigned</div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagersArchitectsCard;

ManagersArchitectsCard.propTypes = {
  srManagerDisplay: PropTypes.string,
  srManagerDetails: PropTypes.object,
  managerRows: PropTypes.arrayOf(PropTypes.object),
  srArchitects: PropTypes.arrayOf(PropTypes.object),
  architects: PropTypes.arrayOf(PropTypes.object),
  deliveryManagerRows: PropTypes.arrayOf(PropTypes.object),
};

ManagersArchitectsCard.defaultProps = {
  srManagerDisplay: '-',
  srManagerDetails: null,
  managerRows: [],
  srArchitects: [],
  architects: [],
  deliveryManagerRows: [],
};
